import { ReactNode, createContext, useContext } from 'react';
import useFetchPartnerAccounts from '../hooks/useApi/useFetchPartnerAccounts';

import type { FetchPartnerAccountsResponse, PartnerAccountsRequest } from '../hooks/useApi/useFetchPartnerAccounts';

type PartnerAccountsCtx = {
  response: FetchPartnerAccountsResponse | undefined;
  refreshPartnerAccounts: (params?: PartnerAccountsRequest) => void;
  reset: () => void;
};

const defaultData = {
  success: false,
  errorMessage: '',
  accountDetails: {},
  balances: [],
  permissions: {},
  PaginationMetaData: { Limit: 20, Offset: 0, TotalRecords: 0 },
};

export const PartnerAccountsContext = createContext<PartnerAccountsCtx>({
  response: defaultData,
  refreshPartnerAccounts: () => {},
  reset: () => {},
});

export const PartnerAccountsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, refreshPartnerAccounts, reset] = useFetchPartnerAccounts({});

  return (
    <PartnerAccountsContext.Provider
      value={{
        response,
        refreshPartnerAccounts,
        reset,
      }}
    >
      {children}
    </PartnerAccountsContext.Provider>
  );
};

export const usePartnerAccounts = (): PartnerAccountsCtx => useContext(PartnerAccountsContext);
